<template></template>

<script>
import DOMPurify from 'dompurify';
export default {
    name: 'measure-item',
    props: ['options', 'measure_tool'],
    data: function() {
        return {
            unit: this.options.unit || 'km', //m|km
            color: this.options.color || '#ff2a2a',
            pane_name: this.options.pane_name,
            pane: this.options.pane,
            layer_group: L.layerGroup(),
            latlngs: [],
            polygon_latlngs: [],
            poly_item: null,
            edit_markers: [],
            distance_markers: [], //距離標籤的marker
            distance_latlngs: [], //距離標籤的marker經緯度
            distance_vals: [], //各點距離數值
            show_distance: this.options.show_distance === false ? false : true,
            show_center_btn: this.options.show_center_btn === false ? false : true,
            show_area: this.options.show_area === false ? false : true,
            center_marker: null,
            center_marker_icon:
                this.options.center_marker_icon ||
                L.divIcon({
                    iconSize: [32, 32],
                    className: 'measure-center-marker',
                    html: '×',
                    riseOnHover: true,
                    riseOffset: 999,
                    zIndexOffset: 999,
                }),
        }
    },
    computed: {
        is_area: function() {
            return this.latlngs.length > 2 && this.options.type === 'area' ? true : false
        },
    },
    mounted: function() {
        this.latlngs = this.options.latlngs.map((latlng) => {
            if (Array.isArray(latlng)) {
                const clean_lat = DOMPurify.sanitize(latlng[1]);
                const clean_lon = DOMPurify.sanitize(latlng[0]);
                return L.latLng(clean_lat, clean_lon)
            }

            return latlng
        })

        if (this.is_area) {
            this.poly_item = L.polygon([], {
                pane: this.pane_name,
                color: this.color,
                weight: 1,
                interactive: false,
                zIndexOffset: 997,
            }).addTo(this.layer_group)
        } else {
            this.poly_item = L.polyline([], {
                pane: this.pane_name,
                color: this.color,
                weight: 1,
                interactive: false,
                zIndexOffset: 997,
            }).addTo(this.layer_group)
        }

        this.edit_markers = this.latlngs.map((latlng, i) => {
            const marker = L.marker(latlng, {
                pane: this.pane_name,
                icon: L.divIcon({
                    iconSize: [15, 15],
                    className: 'measure-item-edit-marker',
                }),
                riseOnHover: true,
                riseOffset: 9999,
                draggable: true,
            }).addTo(this.layer_group)

            marker
                .on('drag', (e) => {
                    this.polygon_latlngs.splice(i, 1, e.latlng)
                })
                .on('dragend', (e) => {
                    const latlngs = JSON.parse(JSON.stringify(this.polygon_latlngs))
                    if (this.measure_tool.dragged) {
                        this.measure_tool.dragged(latlngs, e)
                    }

                    if (this.options.dragged) {
                        this.options.dragged(latlngs, e)
                    }
                })

            return marker
        })

        if (this.show_distance) {
            this.distance_markers = this.latlngs.map((latlng) => {
                return L.circle([90, 180], {
                    pane: this.pane_name,
                    color: 'transparent',
                    zIndexOffset: 998,
                })
                    .bindTooltip('', {
                        direction: 'center',
                        permanent: true,
                        className: 'measure-distance-tag',
                    })
                    .openTooltip()
                    .addTo(this.layer_group)
            })
            if (!this.is_area) {
                this.distance_markers.shift()
            }
        }

        this.center_marker = L.marker([180, 90], {
            icon: this.center_marker_icon,
            pane: this.pane_name,
        }).addTo(this.layer_group)

        if (this.show_area) {
            this.center_marker
                .bindTooltip('', {
                    direction: 'top',
                    offset: [0, -10],
                    permanent: true,
                })
                .openTooltip()
        }

        this.center_marker.on('click', () => {
            this.delete()

            if (this.measure_tool.destory) {
                this.measure_tool.destory()
            }
            if (this.options.destory) {
                this.options.destory()
            }
        })

        this.layer_group.addTo(this.pane)

        this.polygon_latlngs = this.latlngs.slice()

        this.options.delete = this.delete

        // after draw
        const latlngs = JSON.parse(JSON.stringify(this.polygon_latlngs))
        if (this.measure_tool.callback) {
            this.measure_tool.callback(latlngs)
        }
        if (this.options.callback) {
            this.options.callback(latlngs)
        }
    },
    methods: {
        set_distance_markers_latlngs: function(latlngs) {
            if (!this.show_distance) {
                return
            }

            const length = latlngs.length
            let last_marker_latlng = latlngs[length - 1]

            const d_vals = []
            const d_latlngs = latlngs.map((latlng) => {
                const marker_latlng = this.measure_tool.get_center_latlng(last_marker_latlng, latlng)
                const distance = this.measure_tool.get_format_distance(last_marker_latlng, latlng, this.unit)
                d_vals.push(distance)

                last_marker_latlng = latlng

                return marker_latlng
            })
            if (!this.is_area) {
                d_vals.shift()
                d_latlngs.shift()
            }

            this.distance_vals = d_vals
            this.distance_latlngs = d_latlngs
        },
        set_area_marker: function(latlngs) {
            if (!this.show_center_btn) {
                return
            }

            // set center btn location
            let c_latlngs = {
                lat: this.polygon_latlngs[0].lat + 0.25,
                lng: this.polygon_latlngs[0].lng,
            }
            if (this.is_area) {
                c_latlngs = this.poly_item.getBounds().getCenter()
            }
            this.center_marker.setLatLng(c_latlngs)

            if (!this.show_area) {
                return
            }

            if (!this.is_area) {
                this.center_marker.closeTooltip()
                return
            }

            const area = this.measure_tool.get_format_area(latlngs, this.unit)
            this.center_marker.setTooltipContent(area)
        },
        delete: function() {
            this.layer_group.clearLayers()
        },
    },
    watch: {
        polygon_latlngs: function(latlngs) {
            this.options.latlngs = latlngs

            // update poly_item
            this.poly_item.setLatLngs(latlngs)

            // update distance
            this.set_distance_markers_latlngs(latlngs)

            // update area
            this.set_area_marker(latlngs)
        },
        distance_latlngs: function(latlngs) {
            this.distance_markers.forEach((marker, i) => {
                marker.setLatLng(latlngs[i]).setTooltipContent(String(this.distance_vals[i]))
            })
        },
    },
    beforeDestroy: function() {
        this.delete()
    },
}
</script>

<style>
.measure-item-edit-marker {
    background-color: #ff4545;
    border-radius: 50%;
    border: 0.06em solid #eee;
}
.leaflet-tooltip.measure-distance-tag {
    padding: 0.1em;
    font-family: monospace;
    line-height: 1;
    color: #909399;
}
.measure-center-marker {
    font-size: 3em;
    line-height: 1;
    text-align: center;
    color: #fff;
    background-color: rgba(102, 102, 102, 0.5);
    border-radius: 50%;
}
.measure-center-marker:hover {
    background-color: rgba(102, 102, 102, 0.9);
    transition: 0.1s;
}
</style>
